module.exports = __webpack_public_path__ + "img/no-data-index.262db115.svg";